import {horsesConstants} from "./horsesConstants";

const defaultSelectedFilters = [
    {
      name: "status",
      values: ["true"],
      condition: "equal",
      type: "boolean",
    },
    {
      name: "dateOfBirth",
      values: [],
      condition: "between",
      type: "date",
    },
    {
      name: "father",
      values: [],
      condition: "equal",
      type: "object",
      search: ""
    },
    {
      name: "mother",
      values: [],
      condition: "equal",
      type: "object",
      search: ""
    },
    {
      name: "location",
      values: [],
      condition: "equal",
      type: "object",
      search: ""
    },
    {
      name: "clasificationName",
      values: [],
      condition: "equal",
      type: "object",
      search: ""
    },
    {
      name: "owner",
      values: [],
      condition: "equal",
      type: "object",
      search: ""
    },
    {
      name: "sex",
      values: [],
      condition: "equal",
      type: "object",
    },
];

const initialState = {
    search: '',
    selectedFilters: defaultSelectedFilters
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case horsesConstants.CHANGE_SEARCH:
            return {
                ...state,
                search: action.payload
            };
        case horsesConstants.CLEAR_SEARCH:
            return {
                ...state,
                search: ""
            };
        case horsesConstants.SET_FILTERS:
            return {
                ...state,
                selectedFilters: action.payload
            };
        case horsesConstants.CLEAR_FILTERS:
            return {
                ...state,
                selectedFilters: defaultSelectedFilters
            };
        case horsesConstants.UPDATE_FILTER:
            const { name, filterData } = action.payload;
            const newFilters = state.selectedFilters.filter((f) => f.name !== name);
            newFilters.push(filterData);
            return {
                ...state,
                selectedFilters: newFilters
            };
        default:
            return state
    }
};

export default reducer;